import { Component, OnInit, inject } from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Store } from '@ngrx/store';
import { BaseState } from '../../reducers';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { UserActions } from '../../users/store/user.actions';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import { DividerModule } from 'primeng/divider';
import { Firestore, doc, onSnapshot } from '@angular/fire/firestore';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { FirebaseFunctionService } from '../../services/firebase-function.service';

@Component({
  selector: 'app-render-pipeline-dialog',
  standalone: true,
  imports: [
    InputGroupModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    AsyncPipe,
    ToastModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    DividerModule,
    DynamicDialogModule
  ],
  templateUrl: './render-pipeline-dialog.component.html',
  styleUrl: './render-pipeline-dialog.component.scss',
})
export class RenderPipelineDialogComponent implements OnInit {
  private firestore = inject(Firestore)
  private functions = inject(FirebaseFunctionService)


  renderPipelineId$ = this.store.select(state => state.user?.openRenderPipelineId);
  statusMessage = "Waiting on Roblox Studio..."
  completionPercentage = 0
  renderPipelineId: string
  renderCancelled = false

  constructor(
    private dialog: DynamicDialogRef,
    private store: Store<BaseState>,
    //private messageService: MessageService,
    //private router: Router
  ){
  }

  async ngOnInit(){
    const renderPipelineId = await firstValueFrom(this.renderPipelineId$)
    if (!renderPipelineId) {
      return
    }
    this.renderPipelineId = renderPipelineId
    onSnapshot(doc(this.firestore, `renderPipelines`, renderPipelineId), (doc) => {
      if (!doc.exists()) {
        return
      }
      if (this.renderCancelled) {
        this.statusMessage = 'Cancelling Render'
        this.completionPercentage = 100
        setTimeout(() => {
          this.dialog.close()
        }, 2000)
        return
      }
      const data = doc.data()
      if (data['status'] === 'closed') {
        this.statusMessage = 'Render Complete'
        this.completionPercentage = 100
        setTimeout(() => {
          this.dialog.close()
        }, 3000)
        return
      }
      if (data['combinationInProgress']) {
        this.statusMessage = 'Combining Chunks...'
        this.completionPercentage = (data['chunksRecieved'] / (data['totalChunks'] + 1)) * 100
        return
      }
      if (data['chunksRecieved'] > 0 && data['totalChunks']) {
        this.statusMessage = `Receiving Chunks [${data['chunksRecieved']}/${data['totalChunks']}]`
        this.completionPercentage = ((data['chunksRecieved'] - 1) / (data['totalChunks'] + 1)) * 100
      }
    })
  }

  copyToClipboard() {
    this.store.dispatch(UserActions.copyRenderId());
  }

  focused() {// defocus on focus
    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }
  }

  async closePipeline() {
    await httpsCallable(this.functions.functions, 'cancelRender')()
    this.renderCancelled = true
  }
}
